import { Injectable } from '@angular/core';

import { Response } from '../../../../shared/models/api';
import { API_ENDPOINTS } from '../../../../shared/utils/api-endpoints';
import { ApiService } from '../api.service';

import { Observable } from 'rxjs';

/**
 * Dedicated service for the logged-in user's own permissions.
 * Calls GET /hr/me/permissions, which derives the roles from the token server-side and returns the
 * merged scopes in a single response. Kept separate from HrService.getKeycloakRolesPermissionList
 * (scope-list), which serves the role-admin UI.
 */
@Injectable({
  providedIn: 'root',
})
export class PermissionsService extends ApiService {
  private endpoint = API_ENDPOINTS.HR;

  getMyPermissions(): Observable<Response<{ permission_token: string }>> {
    return this.get<Response<{ permission_token: string }>>({
      operation: 'fetchMyPermissions',
      url: this.endpoint.myPermissions(),
    });
  }
}
